import { LOGIN_TIME } from '../../consts/localStorage';

export const setLoginTime = () => {
  localStorage.setItem(
    LOGIN_TIME,
    JSON.stringify(Math.floor(new Date().getTime() / 1000))
  );
};
